/**
 * Default plot stroke palette shared by every graph dialog.
 *
 * 30 distinct colours chosen to contrast against the white chart background and
 * stay distinguishable from one another. Cycled per plot index
 * (`PLOT_COLOURS[i % PLOT_COLOURS.length]`) so each trace in a multi-plot graph
 * gets a distinct stroke, and offered as the quick-pick "Plot palette" in the
 * legend colour picker (the picker grid wraps at ten swatches per row).
 *
 * The first twelve are the legacy Tiger graph colours, so they lead the cycle.
 * The next ten are the Okabe–Ito colour-blind-safe set (plus a couple of Paul
 * Tol hues), followed by eight more extended distinct hues (Paul Tol /
 * ColorBrewer style) for graphs with many plots.
 *
 * This is the single source of truth — `GraphWindow`, `GraphWindowXY` and
 * `buildTagGraphParams` all import it, so the palette can never drift.
 *
 * References: Okabe & Ito, "Color Universal Design" (2008); Paul Tol's notes.
 */
export const PLOT_COLOURS = [
  // Legacy Tiger graph colours (lead the cycle).
  "#D40260",
  "#0190AC",
  "#FF03FF",
  "#FE9732",
  "#FF2F19",
  "#707071",
  "#217FFF",
  "#2AFEF2",
  "#D0D0D1",
  "#FEF232",
  "#1EC303",
  "#09C2FF",
  // Okabe–Ito (colour-blind safe).
  "#0072B2", // blue
  "#E69F00", // orange
  "#009E73", // bluish green
  "#D55E00", // vermillion
  "#CC79A7", // reddish purple
  "#56B4E9", // sky blue
  "#000000", // black
  "#F0E442", // yellow
  "#117733", // forest green
  "#882255", // wine
  // Extended distinct hues.
  "#44AA99", // teal
  "#AA4499", // orchid
  "#332288", // indigo
  "#999933", // olive
  "#661100", // dark red-brown
  "#CC6677", // rose
  "#6699CC", // steel blue
  "#DDCC77", // sand
] as const;
